import React from 'react';
import './button.css';
import Image from "../theme/Image";

export default function ({className = '', image, title}) {
    return (
        <div className={"buttonContainer " + className} style={{
            overflow: 'hidden',
            margin: '0.71rem 2.86rem'
        }}>
            <div style={{
                margin: '0 auto',
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                height: '8.57rem'
            }}>
                <Image image={image} style={{
                    width: '3.86rem'
                }} alt={"MOP"}/>
                <span className={"uppercaseText"} style={{
                    marginLeft: '1.07rem',
                    fontSize: '1.29rem'
                }}>
                    { title }
                </span>
            </div>
        </div>
    );
}